import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import PlatformPage from "@/pages/PlatformPage";
import AuditReportPage from "@/pages/AuditReportPage";
import SolutionsPage from "@/pages/SolutionsPage";
import SolutionSubpage from "@/pages/SolutionSubpage";
import BookDemoPage from "@/pages/BookDemoPage";
import ContactPage from "@/pages/ContactPage";
import WhyEstheraPage from "@/pages/WhyEstheraPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import BrokeragesPage from "@/pages/BrokeragesPage";
import DevelopersPage from "@/pages/DevelopersPage";
import InvestorsPage from "@/pages/InvestorsPage";
import PropertyTeamsPage from "@/pages/PropertyTeamsPage";
import EnterprisesPage from "@/pages/EnterprisesPage";
import CompanyPage from "@/pages/CompanyPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ArticlePage from "@/pages/ArticlePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import "@/App.css";

// Wrap Routes so the whole route tree keys off pathname → luxe-page-in fires
// on every navigation, giving a cinematic 320ms fade+slide.
function RoutedApp() {
  const location = useLocation();
  return (
    <div key={location.pathname} className="luxe-page-in">
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/platform" element={<PlatformPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/solutions/brokerages" element={<BrokeragesPage />} />
        <Route path="/solutions/developers" element={<DevelopersPage />} />
        <Route path="/solutions/investors" element={<InvestorsPage />} />
        <Route path="/solutions/property-teams" element={<PropertyTeamsPage />} />
        <Route path="/solutions/enterprises" element={<EnterprisesPage />} />
        <Route path="/solutions/:slug" element={<SolutionSubpage />} />
        <Route path="/get-your-audit-report" element={<AuditReportPage />} />
        <Route path="/book-demo" element={<BookDemoPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/why-esthera" element={<WhyEstheraPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/resources/:slug" element={<ArticlePage />} />
        <Route path="/admin/leads" element={<AdminLeadsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <RoutedApp />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0E1422",
            border: "1px solid rgba(96,165,250,0.25)",
            color: "#D8DEE9",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
